import {
  TOGGLE_DOCUMENT_MODAL,
  CHECK_DOCUMENT_FAILURE,
  ACCEPT_TERMS_OF_USE,
} from "../actions/ttDocumentsActions";
import { AnyAction } from "redux";

export interface IDocumentReducerState {
  showModal: boolean;
  errorInfo: { [key: string]: string };
  termOfUseAccepted: boolean;
}

const initialState = {
  showModal: false,
  errorInfo: null,
  termOfUseAccepted: false,
};

export default function ttDocumentsReducer(
  state: IDocumentReducerState = initialState,
  action: AnyAction
) {
  switch (action.type) {
    case TOGGLE_DOCUMENT_MODAL:
      return {
        ...state,
        showModal: !state.showModal,
      };
    case CHECK_DOCUMENT_FAILURE:
      return {
        ...state,
        errorInfo: action.payload.errorResponse.errorInfo,
      };
    case ACCEPT_TERMS_OF_USE:
      return {
        ...state,
        termOfUseAccepted: action.payload.value,
      };
    default:
      return state;
  }
}
